import { ThemeOptions } from '@mui/material';

/**
 * Theme override for MUI ToggleButtonGroup component
 */
export const MuiToggleButtonGroup: ThemeOptions['components']['MuiToggleButtonGroup'] = {
  defaultProps: {
    color: 'primary'
  }
};
